import React from "react";
import PropTypes from "prop-types";
import "./SingleChartCard.css";

const SingleChartCard = ({ title, desc, icon, chart }) => {
  return (
    <div className="single-chart-card">
      <div className="card-header">
        <span className="material-icons card-icon">{icon}</span>
        <div>
          <h3 className="card-title">{title}</h3>
          {desc && <p className="card-desc">{desc}</p>}
        </div>
      </div>
      <div className="card-chart">{chart}</div>
    </div>
  );
};

SingleChartCard.propTypes = {
  title: PropTypes.string.isRequired,
  desc: PropTypes.string,
  icon: PropTypes.string,
  chart: PropTypes.node.isRequired,
};

SingleChartCard.defaultProps = {
  desc: "",
  icon: "bar_chart",
};

export default SingleChartCard;
